<div class="chip-wrapper" [ngClass]="type.kind !== 'default' ? type.kind : ''">
    <span *ngIf="displayIconForChipType()" class="chip-icon {{type.icon}}"></span>
    <label class="chip-text">{{text}}</label>
    <span *ngIf="closeable" class="chip-close-btn" (click)="onClose()"></span>
</div>
